import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import { USAGE_TYPES } from '../../../Utils/Enums';

import styles from './PlanInfoQuickView.styles';

const PlanInfoQuickView = ({
  name,
  id,
  usageData,
  numberOfUsers,
  price,
  currency,
  isCurrencyFirst,
}) => {
  const getLabel = usageType => {
    switch (usageType) {
      case USAGE_TYPES.DATA:
        return 'soho_plan_info_quick_view_data_text';
      case USAGE_TYPES.CALLS:
        return 'soho_plan_info_quick_view_mins_text';
      case USAGE_TYPES.SMS:
        return 'soho_plan_info_quick_view_sms_text';
    }
  };

  const renderUsageItem = (label, value) => {
    return (
      <View style={styles.usageItemStyle}>
        <VFText style={styles.labelsStyle} i18nKey={`${label}`} />
        <VFText style={styles.labelsStyle} i18nKey={`${value}`} />
      </View>
    );
  };
  const renderUsages = () => {
    const isAllUnlimited = usageData.every(item => usageData.length >= 3 && item.isUnlimited);
    if (isAllUnlimited) {
      return renderUsageItem(
        'soho_plan_info_quick_view_plan_text',
        'soho_plan_info_quick_view_unlimited_text',
      );
    }
    return usageData.map(usage => {
      const value = !usage.isUnlimited
        ? usage.usageType === USAGE_TYPES.DATA
          ? usage.totalAmount + usage.totalUnits
          : usage.totalAmount
        : 'soho_plan_info_quick_view_unlimited_text';

      const label = getLabel(usage.usageType);

      return renderUsageItem(label, value);
    });
  };
  const renderMonthlyCostAndNumberOfUsers = () => {
    return (
      <View>
        <View style={styles.usageItemStyle}>
          <VFText
            style={styles.labelsStyle}
            i18nKey="soho_plan_info_quick_view_monthly_cost_text"
          />
          <VFText
            style={styles.labelsStyle}
            i18nKey={isCurrencyFirst ? currency + price : price + currency}
          />
        </View>
        <View style={styles.usageItemStyle}>
          <VFText style={styles.labelsStyle} i18nKey="soho_plan_info_quick_view_no_of_users_text" />
          <VFText style={styles.labelsStyle} i18nKey={`${numberOfUsers}`} />
        </View>
      </View>
    );
  };
  const renderTotalToPayAndMonthlyCost = () => {
    return (
      <View style={styles.monthlyCostAndTotalToPayStyle}>
        <View style={styles.usageItemStyle}>
          <VFText
            style={styles.totalToPayAndMonthlyTextStyle}
            i18nKey="soho_plan_info_quick_view_total_to_pay_text"
          />
        </View>
        <View style={styles.divider} />
        <View style={styles.usageItemStyle}>
          <VFText
            style={styles.totalToPayAndMonthlyTextStyle}
            i18nKey="soho_plan_info_quick_view_total_monthly_text"
          />
          <VFText
            style={styles.totalToPayAndMonthlyTextStyle}
            i18nKey={
              isCurrencyFirst
                ? currency + (numberOfUsers * price).toFixed(2).toString()
                : (numberOfUsers * price).toFixed(2).toString() + currency
            }
          />
        </View>
      </View>
    );
  };
  return (
    <>
      <View style={styles.containerStyle}>
        <VFText style={styles.planTitleStyle} i18nKey={name} />
        {renderUsages()}
        {renderMonthlyCostAndNumberOfUsers()}
      </View>
      {renderTotalToPayAndMonthlyCost()}
    </>
  );
};
PlanInfoQuickView.defaultProps = {
  isCurrencyFirst: false,
};
PlanInfoQuickView.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  numberOfUsers: PropTypes.number,
  usageData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      usageType: PropTypes.string,
      icon: PropTypes.string,
      isUnlimited: PropTypes.bool,
      totalAmount: PropTypes.number,
      totalUnits: PropTypes.string,
      remainingAmount: PropTypes.number,
      remainingUnits: PropTypes.string,
      valuePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  price: PropTypes.string,
  currency: PropTypes.string,
  isCurrencyFirst: PropTypes.bool,
};
export default PlanInfoQuickView;
